import { useMutation, useQueryClient } from '@tanstack/react-query';
import { loaders } from './feature-flags.loaders';
import { featureFlagsKeys } from './feature-flags.queries';

export const useUpdateFeatureFlags = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.updateFeatureFlags, {
    onSuccess: () => {
      return queryClient.invalidateQueries(featureFlagsKeys.all);
    },
  });
};
